var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 60,
    viewBox: "0 0 75 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "sitq9n5rja",
    d: "M0 0h75v60H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5hsxup4hab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sitq9n5rja"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#5hsxup4hab)",
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.562 28.004 57.248.847a2.845 2.845 0 0 1 2.198-.135c.695.24 1.304.744 1.648 1.46l3.592 7.363a.885.885 0 0 1-.28 1.115 5.562 5.562 0 0 0-1.407 6.673 5.479 5.479 0 0 0 2.566 2.558 5.53 5.53 0 0 0 3.613.425.894.894 0 0 1 .992.48l3.592 7.364a2.878 2.878 0 0 1-1.324 3.846L16.752 59.153a2.879 2.879 0 0 1-3.846-1.324l-3.568-7.314a.895.895 0 0 1 .3-1.132 5.57 5.57 0 0 0 1.978-3.102 5.498 5.498 0 0 0-.421-3.694 5.53 5.53 0 0 0-2.652-2.606 5.567 5.567 0 0 0-3.715-.34.887.887 0 0 1-1.024-.472l-3.566-7.32a2.864 2.864 0 0 1-.135-2.197c.241-.7.744-1.304 1.46-1.648zm56.47-25.55L2.346 29.611c-.267.131-.455.362-.546.626-.091.264-.085.56.046.829l3.267 6.698a7.373 7.373 0 0 1 4.181.596 7.292 7.292 0 0 1 3.515 3.44 7.305 7.305 0 0 1 .547 4.887 7.324 7.324 0 0 1-2.104 3.662l3.267 6.698c.13.268.361.455.625.546.264.091.561.085.83-.046L71.658 30.39c.268-.13.456-.36.547-.625.09-.264.084-.561-.046-.829l-3.3-6.763a7.334 7.334 0 0 1-6.079-12.462l-3.294-6.756a1.082 1.082 0 0 0-.625-.547 1.06 1.06 0 0 0-.83.046zM15.286 29.76l27.785-13.55a3.205 3.205 0 0 1 2.448-.145 3.195 3.195 0 0 1 1.84 1.621l6.23 12.774a3.19 3.19 0 0 1 .146 2.447 3.204 3.204 0 0 1-1.622 1.84l-27.785 13.55a3.19 3.19 0 0 1-2.448.145 3.215 3.215 0 0 1-1.84-1.621l-6.232-12.768a3.227 3.227 0 0 1 1.478-4.293zm28.575-11.94L16.07 31.366c-.348.17-.596.47-.715.814-.119.345-.108.734.062 1.082l6.23 12.773c.17.347.47.595.815.714.344.119.734.108 1.081-.061l27.785-13.55c.348-.17.596-.47.714-.815a1.414 1.414 0 0 0-.061-1.081L45.757 18.47a1.42 1.42 0 0 0-1.896-.653z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventTicket);
export default __webpack_public_path__ + "static/media/EventTicket.d54e98a4a948000ea954b6969cd3a9ec.svg";
export { ForwardRef as ReactComponent };